export const styles = {
  wrap: {
    minWidth: '68px',
    padding: '6px 12px',
    textAlign: 'center',
    borderRadius: '8px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    width: 'max-content',
    height: 'fit-content',
  },
  completed: {
    background: 'rgba(30, 160, 250, 0.15)',
    color: '#0970BB',
  },
  active: {
    background: 'rgba(0, 150, 6, 0.12)',
    color: '#009606',
  },
  actionRequired: {
    background: 'rgba(179, 15, 89, 0.12)',
    color: '#B30F59',
  },
  approved: {
    background: 'rgba(228, 120, 0, 0.14)',
    color: '#DB6900',
  },
  draft: {
    background: 'rgba(255, 245, 0, 0.31)',
    color: '#825F06',
  },
  inReview: {
    background: 'rgba(217, 217, 255, 0.8)',
    color: '#5305BA',
  },
  reviewBooked: {
    background: '#E6E8FF',
    color: '#11182C',
  },
}
